import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactUsComponent } from './contact-us/components/contact-us/contact-us.component';
import { ContactUsDetailsComponent } from './contact-us/components/contact-us-details/contact-us-details.component';
import { ContactUsHeaderComponent } from './contact-us/components/contact-us-header/contact-us-header.component';
import { ContactUsSubHeaderComponent } from './contact-us/components/contact-us-sub-header/contact-us-sub-header.component';
import { SharedModule } from '../shared/shared.module';
import { HomeModule } from '../Modules/home/home.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../shared/material.module';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { PricingDetailsDataComponent } from './pricing-details-data/pricing-details-data.component';
import { PricingDetailsHeaderComponent } from './pricing-details-header/pricing-details-header.component';
import { CommanHeaderComponent } from './comman-header/comman-header.component';
import { PricingDetailsComponent } from './pricing-details/pricing-details.component';
import { UnauthorisedPageComponent } from './unauthorised-page/unauthorised-page.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
// import { RECAPTCHA_SETTINGS, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from '../services/environment.service';

@NgModule({
    declarations: [
        ContactUsComponent,
        ContactUsDetailsComponent,
        ContactUsHeaderComponent,
        ContactUsSubHeaderComponent,
        PricingDetailsComponent,
        PricingDetailsDataComponent,
        PricingDetailsHeaderComponent,
        CommanHeaderComponent,
        UnauthorisedPageComponent,
        PageNotFoundComponent,
    ],
    imports: [CommonModule, SharedModule, HomeModule, ReactiveFormsModule, MaterialModule, FormsModule, RouterModule, TranslocoModule],
    // RecaptchaModule
    // providers: [
    //     {
    //         provide: RECAPTCHA_SETTINGS,
    //         useFactory: recaptchaFactory,
    //         deps: [EnvironmentService],
    //         // useValue: {
    //         //     siteKey: environment.reCaptchaSiteKey,
    //         // } as RecaptchaSettings,
    //     },
    // ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CommonComponentModule {}
// export function recaptchaFactory(EnvironmentService: EnvironmentService): RecaptchaSettings {
//     return {
//         siteKey: EnvironmentService.getConfig().reCaptchaSiteKey,
//     };
// }
